// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__VtZ98","options":"AnswerScale_options__2COsg","selected":"AnswerScale_selected__32Og_"};